import { render } from "./AddCompanyModal.vue?vue&type=template&id=cc8d6e80"
import script from "./AddCompanyModal.vue?vue&type=script&lang=js"
export * from "./AddCompanyModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__